<template>
    <div
            class="modal fade"
            id="sys_addlayer_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">添加片区</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">公司名称</label>
                            <div class="col-sm-3">
                                <input name value class="form-control" v-model="company_name" readonly/>
                                <input type="hidden" v-model="submitInfo.id"/>
                            </div>
                            <label class="col-sm-3 control-label">片区名称</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="submitInfo.layer_name"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label">片区负责人</label>
                            <div class="col-sm-3">
                                <select
                                        name
                                        class="chosen-select_employments"
                                        id
                                        placeholder="请选择负责人"
                                        v-model="submitInfo.principal_id"
                                >
                                    <option
                                            :value="item.id"
                                            v-for="(item,index) in employments"
                                            :key="index"
                                    >{{item.username}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" data-dismiss="modal" class="btn btn-primary" @click="submit">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        company_name: '',
        layer_name: '',
        companyid: '',
        employments: [], // 组织下雇员列表
        submitInfo: {
          layer_name: '', // 图层名称
          principal_id: '', // 负责人id
          id: '', // 图层id,
          org_id: ''
        }
      }
    },
    props: ['msgLayerid', 'msgLayerinfo'],
    mounted: function () {},
    methods: {
      // 初始化
      intfn: function (param) {
        var self = this

        $('.chosen-select_employments')
          .chosen({
            disable_search_threshold: 10,
            disable_search: true,
            width: '100%'
          })
          .change(function () {
            console.log($('.chosen-select_employments').val())
            self.submitInfo.principal_id = $('.chosen-select_employments').val()
          })
        self.submitInfo = {
          layer_name: '', // 图层名称
          principal_id: '', // 负责人id
          id: '', // 图层id,
          org_id: ''
        }
        self.submitInfo.id = self.msgLayerid
        var companyInfo = localStorage.getItem('companyInfo')
        self.companyid = JSON.parse(companyInfo).id
        self.submitInfo.org_id = JSON.parse(companyInfo).id
        self.company_name = JSON.parse(companyInfo).name
        self.getemployments()
      },
      // 获取组织雇员列表
      getemployments: function () {
        var self = this
        console.log('msgLayerid', self.msgLayerid)
        self.global.axiosGet(
          self,
          'organizations/' + self.companyid + '/employments/',
          function (res) {
            console.log('获取组织雇员列表', res)
            // res.username
            self.employments = res
            console.log(self.employments)
            setTimeout(function () {
              $('.chosen-select_employments').trigger('chosen:updated')
              if (self.msgLayerinfo != '') {
                // 如果为编辑 序言初始数据
                var layerInfo = JSON.parse(self.msgLayerinfo)
                // console.log(layerInfo);
                self.submitInfo.layer_name = layerInfo.name
                for (var i = 0; i < self.employments.length; i++) {
                  if (layerInfo.principal) {
                    if (layerInfo.principal.id == self.employments[i].id) {
                      console.log(
                        'layerInfo.principal.id',
                        layerInfo.principal.id
                      )
                      $('.chosen-select_employments').val(layerInfo.principal.id)
                      $('.chosen-select_employments').trigger('chosen:updated')
                    }
                  }
                }
              }
            }, 500)
          }
        )
      },
      submit: function () {
        var self = this
        var submitJson = self.submitInfo
        // return;
        if (self.msgLayerid == '') {
          // 新增图层
          delete submitJson['id']
          // POST /organization/(_org_id)/layers/
          self.global.axiosPost(
            self,
            'organization/' + submitJson.org_id + '/layers/',
            submitJson,
            function (res) {
              alert('提交成功')
              $('#atptable').bootstrapTable('refresh')
            },
            function (res) {
              alert('没有权限')
            }
          )
        } else {
          // 修改图层
          delete submitJson['org_id']
          self.global.axiosPut(
            self,
            'layer/' + self.msgLayerid + '/',
            submitJson,
            function (res) {
              alert('提交成功')
              $('#atptable').bootstrapTable('refresh')
            },
            function (res) {
              alert('没有权限')
            }
          )
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stationmanager/addlayer.vue